import React, { useEffect, useState } from 'react';
import { SliderHandle } from "./SliderHandle.js";
import { useEventCallback } from "../../../helper/hooks/useEventCallback.js";
import styles from "./SliderHandles.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function SliderHandles({
  stops,
  maxRange,
  minValue,
  trackEle,
  elevations,
  onHandleActive,
  onHandleMoved
}) {
  const [dragging, setDragging] = useState(undefined);
  useEffect(() => {
    onHandleActive(dragging);
  }, [dragging, onHandleActive]);
  const handlePointerMove = useEventCallback(e => {
    if (trackEle && dragging !== undefined) {
      const trackRect = trackEle.getBoundingClientRect();
      const newValue = Math.min(trackRect.width, (e.clientX - trackRect.left) / trackRect.width) * maxRange + minValue;
      onHandleMoved?.(dragging, newValue, true);
    }
  }, [dragging, onHandleMoved]);
  useEffect(() => {
    const handlePointerUp = () => setDragging(undefined);
    window.addEventListener('pointerup', handlePointerUp);
    window.addEventListener('pointermove', handlePointerMove);
    return () => {
      window.removeEventListener('pointerup', handlePointerUp);
      window.removeEventListener('pointermove', handlePointerMove);
    };
  }, [handlePointerMove]);
  return /*#__PURE__*/_jsx("div", {
    className: styles.handles,
    children: stops.map((stop, index) =>
    /*#__PURE__*/
    /* eslint-disable react/no-array-index-key */
    _jsx(SliderHandle, {
      index: index,
      stop: stop,
      elevation: elevations[index],
      maxRange: maxRange,
      minValue: minValue,
      onActive: setDragging
    }, index)
    /* eslint-enable react/no-array-index-key */)
  });
}